export const PHONE_DISPLAY = "+1 (604) 593-5400";
export const PHONE_TEL = "tel:+16045935400";
export const WHATSAPP = "https://wa.me/16045935400";
export const TUITION = "$8,500";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?w=1400&q=80&auto=format&fit=crop",
    clinical: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=1200&q=80&auto=format&fit=crop",
    lab: "https://hccbc.com/assets/img/health-care-assistant-imgg.jpg",
    community: "https://images.unsplash.com/photo-1773227059334-38d10a9075f2?w=1200&q=80&auto=format&fit=crop",
};

const INTAKES = ["2026-03-02", "2026-05-04", "2026-07-06", "2026-09-07", "2026-11-02"];

export const upcomingIntakes = () => {
    const today = new Date().toISOString().slice(0, 10);
    return INTAKES.filter((d) => d >= today).map((d) =>
        new Date(`${d}T12:00:00`).toLocaleDateString("en-CA", { month: "long", day: "numeric", year: "numeric" }),
    );
};

export const FACTS = [
    { k: "25", u: "weeks", label: "Full-time diploma · 769 hours" },
    { k: "210", u: "hrs", label: "Clinical placement in complex care" },
    { k: "60", u: "hrs", label: "Practicum in home support / assisted living" },
    { k: "33102", u: "NOC", label: "Nurse aides & patient service associates" },
];

export const PHASES = [
    {
        id: "phase-1", tab: "Phase I", title: "Theory & lab application", hours: 475,
        courses: [
            ["HCA-1", "Concepts for Practice", 70], ["HCA-2", "Introduction to Practice", 30],
            ["HCA-3", "Interpersonal Communications", 50], ["HCA-4", "Lifestyle and Choices", 30],
            ["HCA-5", "Common Health Challenges", 115], ["HCA-6", "Cognitive and/or Mental Health Challenges", 60],
            ["HCA-7", "Personal Care and Assistance", 120],
        ],
    },
    {
        id: "phase-2", tab: "Phase II", title: "External certifications", hours: 24,
        courses: [["FS-I", "FoodSafe™ Level I", 8], ["BLS", "Basic Life Support (BLS) – CPR Training", 16]],
    },
    {
        id: "phase-3", tab: "Phase III", title: "Real-world practice experience", hours: 270,
        courses: [
            ["HCA-8", "Clinical Placement in Multi-Level and/or Complex Care", 210],
            ["HCA-9", "Practicum Experience in Home Support and/or Assisted Living", 60],
        ],
    },
];

export const CAREERS = [
    ["Complex Care", "Long-term care homes supporting residents with high-acuity needs."],
    ["Acute Care", "Hospital units working alongside nurses and the care team."],
    ["Home Support", "Helping clients live safely and independently at home."],
    ["Assisted Living", "Supporting seniors with daily living and wellbeing."],
    ["Group Homes", "Person-centred care for adults with diverse abilities."],
    ["Adult Day Care", "Community programs that keep clients active and connected."],
];

export const ENGLISH_TESTS = [
    ["IELTS (Academic / General)", "Overall 6 · Speaking & Listening 6 · Reading & Writing 5.5"],
    ["CELPIP General", "Listening 7 · Speaking 7 · Reading 6 · Writing 6"],
    ["CLB / CLBPT", "Listening 7 · Speaking 7 · Reading 6 · Writing 6"],
    ["CAEL", "Overall 60 · no section below 50"],
    ["PTE Academic", "Overall 50 · Speaking & Listening 50 · Reading & Writing 45"],
    ["TOEFL iBT", "Overall 76 · Speaking & Listening 20 · Reading & Writing 18"],
];

export const FORM_OPTIONS = {
    status: [
        "Canadian Citizen", "Permanent Resident", "Work Permit Holder",
        "Study Permit Holder", "Visitor / Other", "Outside Canada",
    ],
    english: [
        "Completed English 10 (or higher) in Canada",
        "Passed IELTS / CELPIP / CLB / CAEL / PTE",
        "Booked a test, waiting for results",
        "Haven't taken a test yet",
    ],
    time: ["Morning (9am – 12pm)", "Afternoon (12pm – 5pm)", "Evening (5pm – 8pm)", "Anytime"],
    police: ["Yes, I have it", "Applied / in progress", "Not yet"],
};

export const FAQS = [
    ["Is this program recognized in BC?", "Yes. The program is approved by the Private Training Institution Branch (PTIB) and follows the BC provincial HCA curriculum reviewed by the BC Care Aide & Community Health Worker Registry, so graduates can register and work as Health Care Assistants in BC."],
    ["How long does it take?", "25 weeks full-time (769 hours), including 210 hours of clinical placement and a 60-hour community practicum."],
    ["Where are classes held?", "On-site at our Surrey, BC campus, with course materials and live instructor interaction supported through our learning platform."],
    ["How much does it cost and can I get funding?", `Tuition is ${TUITION}. Eligible students may apply for BC Student Loans and scholarships — our Financial Aid Officers help you every step of the way.`],
    ["What English level do I need?", "English 10 (or equivalent) if you've had 3+ years of full-time English instruction; otherwise a recognized test such as IELTS 6.0 or CELPIP 7-7-6-6. Institution-made tests are not accepted."],
    ["Do I need a police certificate?", "International applicants need a clear police certificate from their country of origin. A BC criminal record check is also completed before clinical placement."],
    ["Is the program PGWP eligible?", "No. This program is not eligible for the Post-Graduation Work Permit (PGWP), and the college does not provide immigration or visa services."],
];
